<template>
<div>
    <div class="wise-spinner-backdrop" :style="{ display: show ? 'block' : 'none' }"></div>
    <div class="wise-spinner" :style="{ display: show ? 'block' : 'none' }">
        <div class="spinner">
            <img :src="spinnerUrl" alt="Spinner animation">
        </div>
        <p class="lead">{{ overrideMessage || $_locale('processing') }}...</p>
    </div>
</div>
</template>

<script>
export default {
    data: () => ({
        show: false,
        overrideMessage: null,
    }),
    computed: {
        spinnerUrl() {
            const { ASSETS_SRC } = window.wisenetwork
            return `${ ASSETS_SRC }/assets/images/spinner_96x96.gif`
        },
    },
    methods: {
        open(message = null) {
            if (message) {
                this.overrideMessage = message;
            }

            this.show = true;
        },
        close() {
            this.show = false;
            this.overrideMessage = null;
        },
    },
}
</script>

<style scoped>
.wise-spinner-backdrop {
    background-color: rgba(22, 22, 22, .5);
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    overflow: hidden;
    display: none;
    z-index: 1999;
}
.spinner {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    margin: 20px auto;
    position: relative;
    box-sizing: content-box;
}
.spinner img {
    width: 100%;
    width: 75%;
    border-radius: 50%;
}

.wise-spinner {
    background-color: #ffffff;
    width: 478px;
    padding: 17px;
    border-radius: 5px;
    text-align: center;
    position: fixed;
    left: 50%;
    top: 50%;
    margin-left: -256px;
    margin-top: -200px;
    overflow: hidden;
    display: none;
    z-index: 2000;
}

.lead {
    margin-bottom: 18px;
    font-size: 14px;
    font-weight: 200;
    line-height: 1.4;
}

@media only screen and (min-width: 768px) {
    .lead {
        font-size: 19.5px;
    }
}
</style>